<ng-container *transloco="let t;">
    <div class="admin-layout">
        <div class="app-login-body">
            <img class="login-screen-main-img" src="../../assets/app-assets/images/general/login-screen-main-img.svg" alt="">
            <img class="login-screen-pattren-img" src="../../assets/app-assets/images/general/login-pattern.svg" alt="">
            
            <div class="login-header d-flex justify-content-between">
                <div>
                    <div class="logo">
                        <img src="../../assets/app-assets/images/logo/logo-yellow.svg" alt="">
                    </div>
                    <p class="text clr-white fs-12">Customizable connectivity solutions that<br>matter to your business.</p>
                </div>
                <div class="login-page-lang">
                    <app-language-changer />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                </div>
                <div class="col-md-6">

                    <div class="card login-form">
                        <div class="card-body">
                            <div class="text-center mb-4">
                                <p class="title clr-primary xl font-m">{{t('changeYourPassword')}}</p>
                                <p class="text">{{t('pleaseChoosePassword')}}</p>
                            </div>
                            <form [formGroup]="forgotForm" (ngSubmit)="forgotSubmit()" class="form flex flex-column"
                                novalidate>
                                <div class="form-container">

                                    <div class="field">
                                        <label>{{t('createYourNewPassword')}}</label>
                                        <span class="p-input-icon-right">
                                            <input formControlName="password"
                                                [type]="showPassword ? 'text' : 'password'" autocomplete="off"
                                                pInputText [placeholder]="t('newPassword')">
                                            <i *ngIf="showPassword" class="pi pi-eye" (click)="showHidePassword()"></i>
                                            <i *ngIf="!showPassword" class="pi pi-eye-slash"
                                                (click)="showHidePassword()"></i>
                                        </span>

                                    </div>
                                    <div class="field">
                                        <!-- <input formControlName="confirmPassword" type="password" autocomplete="off" pInputText
                                    placeholder="Confirmer nouveau mot de passe"> -->

                                        <span class="p-input-icon-right">
                                            <input formControlName="confirmPassword"
                                                [type]="showConfirmPassword ? 'text' : 'password'" autocomplete="off"
                                                pInputText [placeholder]="t('confirmNewPassword')">
                                            <i *ngIf="showConfirmPassword" class="pi pi-eye"
                                                (click)="showHideConfirmPassword()"></i>
                                            <i *ngIf="!showConfirmPassword" class="pi pi-eye-slash"
                                                (click)="showHideConfirmPassword()"></i>
                                        </span>
                                    </div>

                                    <div class="d-flex flex-column gap-1 mb-3">
                                        <p class="text">{{t('passwordStrength')}}
                                            <span class="clr-danger"
                                                *ngIf="forgotForm.controls['password'].invalid && (forgotForm.controls['password'].dirty || forgotForm.controls['password'].touched); else showCorrect">
                                                {{t('bad')}}
                                            </span>
                                            <ng-template #showCorrect>
                                                <span class="clr-success"
                                                    *ngIf="forgotForm.controls['password'].invalid === false">
                                                    {{t('good')}}
                                                </span>
                                            </ng-template>
                                        </p>
                                        <!-- <div class="mt-1">
                                            <p class="text"> <i class="pi mr-2"
                                                    [ngClass]="!forgotForm.get('password').value || (forgotForm.get('password').hasError('minlength') || forgotForm.get('password').hasError('maxlength')) ? 'clr-danger pi-times' : 'clr-success pi-check'"></i>
                                                {{t('enter8To16Char')}} </p>
                                            <p class="text"> <i class="pi mr-2"
                                                    [ngClass]="{ 'clr-success pi-check': forgotForm.get('password').value && (forgotForm.get('password').value.match(lowerCasePattern) || forgotForm.get('password').value.match(upperCasePattern)), 'clr-danger pi-times': !forgotForm.get('password').value || (!forgotForm.get('password').value.match(lowerCasePattern) || !forgotForm.get('password').value.match(upperCasePattern)) }"></i>
                                                {{t('oneUpperOneLower')}}</p>
                                            <p class="text"> <i class="pi mr-2"
                                                    [ngClass]="{ 'clr-success pi-check': forgotForm.get('password').value && forgotForm.get('password').value.match(digitPattern), 'clr-danger pi-times': !forgotForm.get('password').value || (!forgotForm.get('password').value.match(digitPattern)) }"></i>
                                                {{t('number')}}</p>
                                            <p class="text"> <i class="pi mr-2"
                                                    [ngClass]="{ 'clr-success pi-check': forgotForm.get('password').value && forgotForm.get('password').value.match(specialCharacterPattern), 'clr-danger pi-times': !forgotForm.get('password').value || (!forgotForm.get('password').value.match(specialCharacterPattern)) }"></i>
                                                {{t('specialCharacters')}} (%#:$*)</p>
                                            <p class="text"> <i class="pi mr-2"
                                                    [ngClass]="{ 'clr-success pi-check': forgotForm.get('confirmPassword').value && !forgotForm.get('confirmPassword').hasError('passwordsMismatch'), 'clr-danger pi-times': !forgotForm.get('confirmPassword').value || forgotForm.get('confirmPassword').hasError('passwordsMismatch') }"></i>{{t('passwordMisMatch')}}
                                            </p>
                                        </div> -->
                                        <div class="mt-1">

                                            <p class="text" *ngFor="let rule of passwordRules">
                                                <i class="pi mr-2" [ngClass]="{
                                            'clr-success pi-check': isRuleValid(rule), 
                                            'clr-danger pi-times': !isRuleValid(rule)
                                          }">
                                                </i>
                                                {{ rule }}
                                            </p>
                                            <p class="text"> <i class="pi mr-2"
                                                    [ngClass]="{ 'clr-success pi-check': forgotForm.get('confirmPassword').value && !forgotForm.get('confirmPassword').hasError('passwordsMismatch'), 'clr-danger pi-times': !forgotForm.get('confirmPassword').value || forgotForm.get('confirmPassword').hasError('passwordsMismatch') }"></i>{{t('passwordMisMatch')}}

                                        </div>
                                    </div>
                                </div>
                                <div class="button-container">
                                    <button type="submit" class="app-button btn-primary w-100" label="Forgot"
                                        [disabled]="!forgotForm.valid">{{t('resetAndConnect')}}
                                        <span style="margin-left: 65%; position: absolute;"><i
                                                *ngIf="showForgotSubmitButtonLoader" style="float: right;"
                                                class="pi pi-spin pi-spinner"></i></span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="login-footer">

                <p class="text text-white fs-12">{{latestYear}} {{t('footerText')}}</p>
            </div>
        </div>

    </div>
</ng-container>